export const SEARCH_TYPES = {
  NAME: 'name',
  RRC: 'rrc',
  UPC: 'upc',
} as const

export type CatalogSearchType = ValueOf<typeof SEARCH_TYPES>
